module.exports = __webpack_public_path__ + "img/seat-5.2f92744b.jpg";